import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import { Line } from 'rc-progress'
import { includes } from 'lodash'

import { MessageErrorInput } from 'Components/Message/Error/input'

import UploadIcon from 'Assets/Images/icons/upload'

import { getFilenameWithExtensionFromUrl, imageExtension } from 'Utils/Regexp'

class DropzoneUnstyled extends PureComponent {
  state = { files: [], percent: 0 }

  uploadIcon = text => (
    <div>
      <UploadIcon />
      <div>{text}</div>
    </div>
  )

  renderUploadIcon = () => {
    const { dropzoneLabel = 'Upload' } = this.props

    const Filepreview = ({ url, type, name = '' }) =>
      includes(type, 'image') || name.match(imageExtension) ? (
        <div
          className="file-preview"
          style={{ backgroundImage: `url(${url})` }}
        />
      ) : (
        this.uploadIcon(name)
      )

    if (!this.state.files.length && this.props.src) {
      return (
        <Filepreview
          url={this.props.src}
          name={getFilenameWithExtensionFromUrl(this.props.src)}
        />
      )
    }

    if (!this.state.files.length) {
      return this.uploadIcon(dropzoneLabel)
    }

    return this.state.files.map((file, i) => (
      <Filepreview
        key={i}
        url={file.preview}
        name={file.name}
        type={file.type}
      />
    ))
  }

  render = (props = this.props) => {
    const {
      accept,
      className,
      input,
      mainLabel,
      multiple = false,
      progress,
      disabled,
    } = props
    let meta = props.meta || {}
    const errorJSX =
      props.error || (meta.touched && meta.error) ? (
        <MessageErrorInput message={meta.error || props.error} />
      ) : null

    return (
      <div className={className}>
        <label>{mainLabel}</label>
        <div className="dropzone-preview">
          <Dropzone
            accept={accept ? accept : ''}
            activeClassName="dropzoneActive"
            className="dropzone"
            multiple={multiple}
            onDrop={(files, ...rest) => {
              this.setState({ files })
              input.onChange(files, ...rest)
            }}
            disabled={disabled}
          />
          {this.renderUploadIcon()}
        </div>
        {progress && (
          <Line
            percent={progress}
            strokeWidth="1"
            strokeColor="#2db7f5"
            strokeLinecap="square"
          />
        )}
        {errorJSX}
      </div>
    )
  }
}

DropzoneUnstyled.propTypes = {
  dropzoneLabel: PropTypes.string,
  mainLabel: PropTypes.string,
  multiple: PropTypes.bool,
}

export { DropzoneUnstyled }



// WEBPACK FOOTER //
// ./src/Components/Form/Dropzone/unstyled.js